import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
 import { ProjectLayoutComponent } from "./core/layouts/project-layout/project-layout.component";
 import { AuthGuardService } from './core/guards/auth-guard.service';
import { ALL_ROUTES } from "./core/routes/all-routes";
 import {LoginModule} from './login/login.module';
import { HomeModule } from './home/home.module';
import { NotFound404Component } from './core/components/not-found404/not-found404.component';
const routes: Routes = [
  {
    path: "dashboard",
    component: ProjectLayoutComponent,
    children: ALL_ROUTES,
    canActivate: [AuthGuardService]
  },
 
   { path: "",loadChildren: ()=> LoginModule},
   { path: "home",loadChildren: ()=> HomeModule,  canActivate: [AuthGuardService]},
  //  { path: 'page-not-found', component: NotFound404Component },
];


@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
